import React, { useEffect, useMemo } from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {
  const lastUpdated = useMemo(() => '2026-02-10', []);

  useEffect(() => {
    document.title = 'Privacy Policy | Tripod Technologies';
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <header className="mb-10">
            <h1 className="text-3xl font-semibold tracking-tight text-gray-900">Privacy Policy</h1>
            <p className="mt-2 text-sm text-gray-600">Last updated: {lastUpdated}</p>
            <p className="mt-6 text-base leading-7 text-gray-700">
              This Privacy Policy explains how Tripod Technologies Private Limited collects, uses, and protects information when you use this website. It also explains how cookies are used and how you can control your preferences.
            </p>
          </header>

          <div className="space-y-10">
            <section>
              <h2 className="text-xl font-semibold text-gray-900">1) Information We Collect</h2>
              <ul className="mt-3 list-disc space-y-2 pl-5 text-base text-gray-700">
                <li>
                  <span className="font-semibold">Information you provide:</span> when you contact us, we may collect your name, email address, phone number, company name, and the contents of your message.
                </li>
                <li>
                  <span className="font-semibold">Usage and device information:</span> we may collect basic technical and usage information such as pages visited, approximate location derived from IP address, device/browser type, and timestamps to help operate and improve the website.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">2) How We Use Information</h2>
              <ul className="mt-3 list-disc space-y-2 pl-5 text-base text-gray-700">
                <li>Operate and maintain the website and our services</li>
                <li>Improve functionality, performance, and user experience</li>
                <li>Protect against fraud, abuse, and security risks</li>
                <li>Respond to inquiries and provide support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">3) Cookies and Similar Technologies</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                We use cookies and similar technologies to support website functionality and remember your preferences. You will see a cookie consent popup that lets you Accept or Reject non-essential cookies. You can change your choice at any time by selecting Cookie settings in the site footer.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">4) Sharing of Information</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                We may share information with service providers that help us run the website (such as hosting and analytics providers), or when required by law.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">5) Data Retention</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                We retain information only for as long as necessary for the purposes described above, unless a longer retention period is required or permitted by law.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">6) Your Choices and Rights</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                Depending on where you live, you may have rights to access, correct, or delete your personal information. To make a request, contact us using the details below.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">7) Contact Us</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                For privacy-related questions or requests, contact: <span className="font-semibold">Info@Tripodtechnologies.com</span>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">8) Changes to This Policy</h2>
              <p className="mt-3 text-base leading-7 text-gray-700">
                We may update this Privacy Policy from time to time. Updates will be reflected by the Last updated date.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

